import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach bearer token (used as fallback + for image query params)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("proam_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function getToken() {
  return localStorage.getItem("proam_token") || "";
}

export function fileUrl(fileId) {
  return `${API}/files/${fileId}?auth=${encodeURIComponent(getToken())}`;
}

export function apiError(detail) {
  if (detail == null) return "Ocurrió un error. Intente de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
